
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.469 2.742h-.805a1.166 1.166 0 00-.25-.562.616.616 0 00-.5-.227c-.557 0-.924.453-1.101 1.36-.094.484-.162 1.307-.204 2.468.552.14 1 .328 1.344.563a3.807 3.807 0 011.5 1.976c.14.412.211.847.211 1.305 0 .542-.088 1.037-.266 1.484a3.624 3.624 0 01-.718 1.172 3.767 3.767 0 01-1.094.805c-.39.193-.81.32-1.258.383-.12.927-.292 1.745-.516 2.453-.49 1.578-1.356 2.367-2.601 2.367-.25 0-.469-.02-.656-.062a2.172 2.172 0 01-.547-.204l.101-1.539h.735c.067.25.166.456.297.618.135.161.325.242.57.242.547 0 .89-.568 1.031-1.703.073-.594.128-1.336.164-2.227-.557-.12-1.01-.3-1.36-.539a3.892 3.892 0 01-.913-.86 3.905 3.905 0 01-.57-1.093 4.05 4.05 0 01-.204-1.29c0-.515.084-.997.25-1.444a3.66 3.66 0 011.797-2.031c.39-.199.823-.331 1.297-.4.125-.989.297-1.812.516-2.468C5.234 1.742 6.125.97 7.39.97c.182 0 .382.026.601.078.224.047.414.107.57.18L8.47 2.742zm-2.172 9.492c.297-.171.55-.388.758-.648.208-.266.367-.568.476-.906.115-.344.172-.72.172-1.125a3.02 3.02 0 00-.555-1.774 2.738 2.738 0 00-.617-.633c-.234-.177-.552-.335-.953-.476-.016.818-.023 1.768-.023 2.851 0 1.11-.042 2.125-.125 3.047.317-.067.606-.18.867-.336zm-3.04-5.25c-.29.167-.543.38-.757.641-.214.26-.38.56-.5.898-.12.339-.18.709-.18 1.11 0 .328.045.643.133.945.094.297.221.57.383.82.167.25.372.477.617.68.24.193.565.341.977.445.015-.562.023-1.174.023-1.835 0-1.532.052-2.876.156-4.032a2.951 2.951 0 00-.851.328z","fill":"currentColor"}})])
          )
        }
      }
    